export const SCENARIO_SATELLITE_GROUPS_ADD_EVENT = 'SCENARIO_SATELLITE_GROUPS_ADD';

export const SCENARIO_SETUP_STATUS = {
    SATELLITE_GROUPS_ADD_SUBMITTED: 'SATELLITE_GROUPS_ADD_SUBMITTED',
    SATELLITE_GROUPS_ADD_IN_PROGRESS: 'SATELLITE_GROUPS_ADD_IN_PROGRESS',
    SATELLITE_GROUPS_ADD_COMPLETED: 'SATELLITE_GROUPS_ADD_COMPLETED',
    SATELLITE_GROUPS_ADD_FAILED: 'SATELLITE_GROUPS_ADD_FAILED',
    ONBOARD_SCHEDULE_GENERATE_SUBMITTED: 'ONBOARD_SCHEDULE_GENERATE_SUBMITTED',
    ONBOARD_SCHEDULE_GENERATE_IN_PROGRESS: 'ONBOARD_SCHEDULE_GENERATE_IN_PROGRESS',
    ONBOARD_SCHEDULE_GENERATE_COMPLETED: 'ONBOARD_SCHEDULE_GENERATE_COMPLETED',
    ONBOARD_SCHEDULE_GENERATE_FAILED: 'ONBOARD_SCHEDULE_GENERATE_FAILED',
} as const;

export type ScenarioSetupStatus = typeof SCENARIO_SETUP_STATUS[keyof typeof SCENARIO_SETUP_STATUS];

const getPayloadCandidates = (source: any): any[] => [
    source,
    source?.data,
    source?.data?.data,
].filter(Boolean);

export const getSatelliteGroupsAddEventType = (source: any): string | undefined => {
    for (const payload of getPayloadCandidates(source)) {
        if (typeof payload?.eventType === 'string') return payload.eventType;
    }
    return undefined;
};

export const getScenarioSetupStatus = (source: any): ScenarioSetupStatus | undefined => {
    for (const payload of getPayloadCandidates(source)) {
        const setupStatus = Object.values(SCENARIO_SETUP_STATUS).find((value) => value === payload?.setupStatus);
        if (setupStatus) return setupStatus;
    }
    for (const payload of getPayloadCandidates(source)) {
        const setupStatus = Object.values(SCENARIO_SETUP_STATUS).find((value) => value === payload?.status);
        if (setupStatus) return setupStatus;
    }
    return undefined;
};

export const getScenarioSetupMessage = (source: any): string | undefined => {
    for (const payload of getPayloadCandidates(source)) {
        const message = payload?.setupStatusMessage;
        if (typeof message === 'string' && message.trim()) return message.trim();
    }
    for (const payload of getPayloadCandidates(source)) {
        const message = payload?.message;
        if (typeof message === 'string' && message.trim()) return message.trim();
    }
    return undefined;
};

export const getSatelliteGroupsAddScenarioId = (source: any): string | undefined => {
    for (const payload of getPayloadCandidates(source)) {
        if (typeof payload?.scenarioId === 'string') return payload.scenarioId;
    }
    return undefined;
};

export const isSatelliteGroupsAddRunning = (status?: ScenarioSetupStatus) => (
    status === SCENARIO_SETUP_STATUS.SATELLITE_GROUPS_ADD_SUBMITTED ||
    status === SCENARIO_SETUP_STATUS.SATELLITE_GROUPS_ADD_IN_PROGRESS
);

export const isOnboardScheduleGenerateRunning = (status?: ScenarioSetupStatus) => (
    status === SCENARIO_SETUP_STATUS.ONBOARD_SCHEDULE_GENERATE_SUBMITTED ||
    status === SCENARIO_SETUP_STATUS.ONBOARD_SCHEDULE_GENERATE_IN_PROGRESS
);
